import { render } from "./txssc.vue?vue&type=template&id=aa4c2d2a&scoped=true"
import script from "./txssc.vue?vue&type=script&lang=js"
export * from "./txssc.vue?vue&type=script&lang=js"

import "./txssc.vue?vue&type=style&index=0&id=aa4c2d2a&lang=scss&scoped=true"
import "./txssc.vue?vue&type=style&index=1&id=aa4c2d2a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa4c2d2a"]])

export default __exports__